export const ENV_DEV = true;
export const ENV_LOCAL = false;

export const API_KEY = 'm1n1st3r10d3c13nc14s_muj3rt1';

export const BASE_API = process.env.URL || 'https://mujerti.mincyt.gob.ve/api';
//'http://localhost:5201/api';

export const MAINTENANCE = process.env.MAINTENANCE || false;
